import React from 'react'

import Image from '@/components/image/image'
import Link from '@/components/link/link'
import TitleLink from '@/components/title-link/title-link'
import useDefaultImages from '@/hooks/useDefaultImages'
import { generateUrl } from '@/internal/utils/generate-url'
import { getModelMessages } from '@/utils/get-model-messages'

const Highlighted: React.FC<{
  highlighted: Queries.PctNavigationItemsFragment['featuredContent']
}> = ({ highlighted }) => {
  const { imgPctNavigationItemsFeatured } =
    useDefaultImages(highlighted?.__typename) ?? {}
  const modelMessages = getModelMessages(highlighted?.__typename)
  if (!highlighted) return null
  const url = generateUrl(highlighted.__typename, highlighted.slug)
  return (
    <div className="col-highlight pt-lg-3">
      <h3 className="title-type">{modelMessages.label}</h3>
      <div className="box-highlighted">
        <div className="image-highlighted">
          <Link to={url}>
            <Image
              image={
                highlighted.image ?? imgPctNavigationItemsFeatured?.desktop
              }
              alt={highlighted.externalName!}
            />
          </Link>
        </div>
        <TitleLink
          title={highlighted.externalName!}
          to={url}
          htmltag="div"
          classes={'link-highlighted'}
        />
        <div className="description">{highlighted.excerpt}</div>
      </div>
    </div>
  )
}
export default Highlighted
